<template>
<div>
  <p>私聊信息管理</p>
</div>
</template>

<script>
  export default {
    name: "PrivateChatRecord"
  }
</script>

<style scoped>

</style>
